import React, { useEffect, useState } from "react";
import {
  PmsPromptConfigPageContainer,
  Content,
} from "./PmsPromptConfigPage.styled";

import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PromptHeader from "../../components/PromptHeader";
import FiltersContainerComponent from "../../components/FiltersContainer";
import { Route, Routes, useNavigate } from "react-router-dom";
import { PromptPage, VersionPage } from "./pages";
import { PromptFormProvider } from "../../context/PromptFormContext";
import { useParams } from "react-router-dom";
import { getPromptById } from "../../../../../services";
import { useStore } from "../../../../../hooks";
import CircularProgress from "@mui/material/CircularProgress";
import { Alert } from "@ann/web-components";

const PmsPromptConfigPage = () => {
  const { promptId } = useParams();
  const { authStore } = useStore();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [promptData, setPromptData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (promptId === 'new') {
      setLoading(false);
      setPromptData(null);
      return;
    }

    const loadPrompt = async () => {
      if (!promptId || !authStore.currentWorkspaceUuid) {
        setError('missing prompt id or account id');
        setTimeout(() => navigate('/v2/pms'), 3000);
        setLoading(false);
        return;
      }

      try {
        const response = await getPromptById({
          id: promptId,
          tenantId: authStore.currentWorkspaceUuid
        });

        if (response?.data) {
          setPromptData(response.data);
        } else {
          setError('Prompt not found');
          setTimeout(() => navigate('/v2/pms'), 3000);
        }
      } catch (err) {
        setError('Error loading prompt'); 
        setTimeout(() => navigate('/v2/pms'), 3000);
      }
      
      setLoading(false);
    };

    loadPrompt();
  }, [promptId, authStore.currentWorkspaceUuid]);

  if (loading) {
    return (
      <PmsPromptConfigPageContainer>
        <CircularProgress />
      </PmsPromptConfigPageContainer>
    );
  }

  if (error) {
    return (
      <PmsPromptConfigPageContainer>
        <Alert
          description={error}
          severity="error"
          closable={true}
          onClose={() => setError(null)}
        />
      </PmsPromptConfigPageContainer>
    );
  }

  return (
    <PromptFormProvider promptData={promptData}>
      <PmsPromptConfigPageContainer>
        <Content>
          <Breadcrumb />
          <PromptHeader promptData={promptData}/>
          <FiltersContainerComponent />
          <Routes>
            <Route index element={<PromptPage />} />
            <Route path="versions" element={<VersionPage />} />
          </Routes>
        </Content>
      </PmsPromptConfigPageContainer>
    </PromptFormProvider>
  );
};

export default PmsPromptConfigPage;
